export interface ILocales {
  path: string;
  isActive?: boolean;
  title?: string;
  isLocal?: boolean; // Переменная говорит о том, что локаль берет данные не отправкой запроса, а локально (переданы из сср)
}
